import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC, useContext } from "react";

const enum fields {
    productNumbers = "productNumbers",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.productNumbers]: string;
    };
}

type Props = OwnProps & HasShellContext;

const ProductConditionalZone: FC<Props> = ({ id, fields, shellContext }) => {
    /** ---------------------------------------------------------
     * Get current product number from ProductContext
     * --------------------------------------------------------- */
    const productContext = useContext(ProductContext);
    const currentProductNumber =
        productContext?.product?.productNumber?.trim().toLowerCase() ?? "";

    const currentManufacturerNumber = 
        productContext.product?.manufacturerItem?.trim().toLowerCase() ?? "";


    const matchedProducts = fields.productNumbers
        ?.split(",")
        .map(x => x.trim().toLowerCase())
        .filter(x => x.length > 0) ?? [];

    /** ---------------------------------------------------------
     * Conditional rendering
     * Always show in CMS editor
     * --------------------------------------------------------- */
    const shouldShow =
        shellContext.isInShell || matchedProducts.includes(currentProductNumber) || matchedProducts.includes(currentManufacturerNumber);

    if (!shouldShow) {
        return null;
    }

    /** ---------------------------------------------------------
     * Render a Zone that editors can fill with Trusted Content
     * --------------------------------------------------------- */
    return (
        <StyledWrapper>
            <Zone contentId={id} zoneName="ConditionalContent" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(ProductConditionalZone),
    definition: {
        group: "Basic",
        canAdd: context => context.permissions?.canUseAdvancedFeatures || false,
        fieldDefinitions: [
            {
                name: fields.productNumbers,
                displayName: "Product Numbers (comma-separated)",
                tooltip: "Enter product numbers that should display this zone",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
